document.querySelector(".popup-btn2").addEventListener('click', function (e) {
  e.stopPropagation();
  document.querySelector(".popup2").style.display = 'block';
}, false);

document.querySelector(".popup-btn2").addEventListener('click', function () {
  document.querySelector(".popup-overlay2").style.display = 'block';
}, false);

document.querySelector(".popup-close2").addEventListener('click', function () {
  document.querySelector(".popup2").style.display = 'none';
  document.querySelector(".popup-overlay2").style.display = 'none';
}, false);

document.querySelector("body").addEventListener('click', function () {
  document.querySelector(".popup2").style.display = 'none';
  document.querySelector(".popup-overlay2").style.display = 'none';
}, false);

document.querySelector(".popup2").addEventListener('click', function (e) {
  e.stopPropagation();
}, false);